/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconCheckedFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCheckedFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.393 3.273C2 3.915 2 4.787 2 6.533v2.934c0 1.745 0 2.618.393 3.26.22.358.522.66.88.88.642.393 1.514.393 3.26.393h2.934c1.745 0 2.618 0 3.26-.393.358-.22.66-.521.88-.88.393-.642.393-1.514.393-3.26V6.533c0-1.746 0-2.618-.393-3.26a2.666 2.666 0 0 0-.88-.88C12.085 2 11.213 2 9.467 2H6.533c-1.746 0-2.618 0-3.26.393-.358.22-.66.522-.88.88Zm4.933 7.393 4.34-4.333-1-1-3.34 3.333-1.993-2-1 1 2.993 3Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCheckedFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCheckedFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.59 4.91C3 5.872 3 7.181 3 9.8v4.4c0 2.619 0 3.928.59 4.89a4 4 0 0 0 1.32 1.32c.962.59 2.271.59 4.89.59h4.4c2.619 0 3.928 0 4.89-.59.538-.33.99-.782 1.32-1.32.59-.962.59-2.271.59-4.89V9.8c0-2.619 0-3.928-.59-4.89a4 4 0 0 0-1.32-1.32C18.128 3 16.819 3 14.2 3H9.8c-2.619 0-3.928 0-4.89.59a4 4 0 0 0-1.32 1.32ZM10.988 16 17.5 9.5 16 8l-5.011 5-2.99-3L6.5 11.5l4.489 4.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconCheckedFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCheckedFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconCheckedFilled16 {...iconProps} />;
        case '24':
            return <IconCheckedFilled24 {...iconProps} />;
        default:
            return <IconCheckedFilled24 {...iconProps} />;
    }
});
